// extracted by mini-css-extract-plugin
export var cardIcon = "_89-5";
export var cardIconUnframed = "_89-9";
export var checkboxCard = "_89-0";
export var checkboxCardSelected = "_89-4";
export var disabled = "_89-2";
export var interactive = "_89-1";
export var outerBorder = "_89-3";
export var spacerMedium = "_89-8";
export var spacerSmall = "_89-7";
export var spacerXsmall = "_89-6";